module.exports = __webpack_public_path__ + "static/img/case_banner_01_h5.4fb81d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_01_h5.png
// module id = B7G4
// module chunks = 34